import TableLogScan from './TableLogScan';

export default TableLogScan;